// extracted by mini-css-extract-plugin
module.exports = {"SearchBar":"SearchBar_SearchBar__psWI_","fullWidth":"SearchBar_fullWidth__hCVhv"};